export enum HrQuantDistributionModalMode {
  VIEW = "view",
  EDIT = "edit",
}
